

const PathList = {
  Login: "/",
  Dashboard: "/dashboard",
  ManageNews: "/manage-news",
  ManagePlayer: "/manage-player",
  ManageClub:"/manage-club",
  ClubDetails:"/club-details/:id",
  CenterManagement:"/center-management",
  ManageFixtures:"/manage-fixtures",
  AddNewReport:"/add-new-report",
  ManageUser:"/manage-user",
};

export default PathList;
